import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import * as React from "react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useActiveFBOs } from "../../../containers/ActiveFBOContainer";
import { useApi } from "../../../containers/ApiContainer";

export const ButtonRemoveFBO: React.FC = () => {
  const { t } = useTranslation();
  const { activeFBO } = useActiveFBOs();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { postgrest } = useApi();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemoveFBO = useCallback(async () => {
    try {
      setLoading(true);
      // Async call to remove the FBO (replace with your actual API call)
      await postgrest
        .from("fbo")
        .delete()
        .eq("id", activeFBO.id);
      // Handle success response
      console.log("FBO removed successfully");
      setOpen(false);
    } catch (error) {
      // Handle error
      console.error("Error removing FBO:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Button
        size="small"
        variant="contained"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={handleOpen}
      >
        {t("screens.superAdmin.buttonRemoveFBO.button")}
      </Button>

      {/* Dialog for confirmation */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("screens.superAdmin.buttonRemoveFBO.dialog.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("screens.superAdmin.buttonRemoveFBO.dialog.message")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("screens.superAdmin.buttonRemoveFBO.dialog.cancelButton")}
          </Button>
          <Button
            onClick={handleRemoveFBO}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : t("screens.superAdmin.buttonRemoveFBO.dialog.confirmButton")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
